
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    name: String,
    idIcon: String,
    desc: String,
    data: String,
    click: Function,
    status: { type: String, default: "" },
    origin: String,
  },
})
export default class ThreeOptionsListNotifications extends Vue {}
